import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/edit/${number | ':jobId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/edit/:jobId`;

export const URL = (jobId: number): RouteDefinition => `${baseRoute}/edit/${jobId}`;
